import { safetyContract, safetyStreamRoute } from './safety.contract';

export { safetyContract, safetyStreamRoute };

export const safetyEngineContracts = {
	safetyContract,
};
